import styles from "./index.module.css";

function StuTrArea(props: any) {
  let myProps = {
    info: {},
    row_num: 0,
    xColumnArr: {},
    open_study_result_popup: (inData: any) => { },
    ...props
  };
  let info = myProps.info;

  const getScoreClass = (score: number) => {
    if (score < 40) return styles.low;
    if (score < 70) return styles.medium;
    return styles.high;
  };

  const get_td_tags = () => {
    let td_tags = myProps.xColumnArr.x_column_list_arr.map((col: any, idx: number) => {
      let key = col.key;
      let val_str: any = "";
      if (info[key]) {
        val_str = info[key];
      }

      if(key=="row_view_result"){
        const score = parseInt(info["a_text_score"]) || 0;
        val_str = (
          <div className={styles.scoreCell}>
            <span className={styles.scoreText}>{score}%</span>
            <span>({info["a_amount"]}/{info["a_success_amount"]})</span>
            <div className={styles.scoreBar}>
              <div
                className={`${styles.scoreBarFill} ${getScoreClass(score)}`}
                style={{ width: `${score}%` }}
              ></div>
            </div>
          </div>
        );
      }

      if(key=="row_view_result_pop"){
        val_str=(
          <button className={styles.viewBtn}
            onClick={()=>{
              myProps.open_study_result_popup({
                stu_seq: info["a_stu_seq"]
              });
            }}
          >결과보기</button>
        );
      }

      return (
        <td key={idx}>
          {val_str}
        </td>
      );
    });
    return td_tags;
  };

  return (
    <tr>
      <td>{myProps.row_num + 1}</td>
      {get_td_tags()}
    </tr>
  );
};
export default StuTrArea;